import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class StaffService {

    constructor(private http: HttpClient) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    getFormDataRequestHeaders() {
        return new HttpHeaders({
            Authorization: localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    get(params: any) {
        return this.http.get(environment.apiUrl + '/staff', {params: params, headers: this.getRequestHeaders()}).toPromise();
    }

    getById(id: string) {
        return this.http.get(environment.apiUrl + '/staff/' + id, {headers: this.getRequestHeaders()});
    }

    delete(id: string) {
        return this.http.delete(environment.apiUrl + '/staff/' + id, {headers: this.getRequestHeaders()});
    }

    approve(id: string) {
        return this.http.put(environment.apiUrl + '/staff/' + id + '/approve', {}, {headers: this.getRequestHeaders()});
    }

    reject(id: string) {
        return this.http.put(environment.apiUrl + '/staff/' + id + '/reject', {}, {headers: this.getRequestHeaders()});
    }

    upload(formData: FormData) {
        return this.http.post(environment.apiUrl + '/staff/upload', formData, {headers: this.getFormDataRequestHeaders()}).toPromise();
    }

    async register(staff: any) {
        try {
            return await this.http.post(environment.authApiUrl + '/signupStaff', staff, {
                headers: this.getPublicRequestHeaders(),
            }).toPromise();
        } catch (e) {
            console.error('error registerStaff: ', e);
            return null;
        }
    }
}
